import {useAuth} from '../../Maindashboard/Context/AuthContext';
export default function FinancialScopeNotice(){
 const {user}=useAuth();
 if(!user||user.role==='super_admin')return null;
 return <div role="note" className="mb-6 rounded-xl border border-amber-400/20 bg-amber-400/5 px-5 py-4 text-sm text-amber-100">Showing authorized branches and departments only. Unassigned historical records and unallocated company opening balances are excluded.</div>;
}
